import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

// Pages
import Home from './pages/Home';
import AboutStory from './pages/about/OurStory';
import TerryBoes from './pages/about/TerryBoes';
import LindaBoes from './pages/about/LindaBoes';

import ServicesOverview from './pages/services/Overview';
import EmergencyPlanning from './pages/services/EmergencyPlanning';
import Compliance from './pages/services/Compliance';
import Drills from './pages/services/Drills';
import TrainingDev from './pages/services/TrainingDev';
import LeadershipDev from './pages/services/LeadershipDev';

import CourseCatalog from './pages/training/Catalog';
import UpcomingCourses from './pages/training/UpcomingCourses';

import Experience from './pages/Experience';
import Industries from './pages/Industries';
import Resources from './pages/Resources';
import FreeConsultation from './pages/FreeConsultation';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen bg-brand-light">
        <Navbar />
        <main className="flex-grow flex flex-col pt-20">
          <Routes>
            <Route path="/" element={<Home />} />
            
            {/* About */}
            <Route path="/about" element={<AboutStory />} />
            <Route path="/about/terry-boes" element={<TerryBoes />} />
            <Route path="/about/linda-boes" element={<LindaBoes />} />
            
            {/* Services */}
            <Route path="/services" element={<ServicesOverview />} />
            <Route path="/services/emergency-planning" element={<EmergencyPlanning />} />
            <Route path="/services/compliance-consulting" element={<Compliance />} />
            <Route path="/services/drills-exercises" element={<Drills />} />
            <Route path="/services/training-development" element={<TrainingDev />} />
            <Route path="/services/leadership-development" element={<LeadershipDev />} />
            
            {/* Training */}
            <Route path="/training/catalog" element={<CourseCatalog />} />
            <Route path="/training/upcoming" element={<UpcomingCourses />} />
            
            {/* Other Pages */}
            <Route path="/experience" element={<Experience />} />
            <Route path="/industries" element={<Industries />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/consultation" element={<FreeConsultation />} />
            <Route path="/contact" element={<Contact />} />
            
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;